import { connect } from 'react-redux';
import ViolinPlot from '../../components/SingleCell/ViolinPlot';

const mapStateToProps = state => ({
  cellPopulation: state.cellPopulation,
});

export default connect(mapStateToProps)(ViolinPlot);



// WEBPACK FOOTER //
// ./src/containers/SingleCell/ViolinPlot.js